import { gql } from '@apollo/client';

export const updateAccount = gql`
  mutation updateAccount($accountCode: String!, $data: AccountInput!) {
    accounts(accountCode: $accountCode, data: $data)
  }
`;
